// API Configuration - Centralized
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://web-production-559c.up.railway.app';

export default API_BASE_URL;



